import React, { FunctionComponent } from 'react';

export interface LawyerProfilProps {
  width?: string;
  height?: string;
}

const LawyerProfil: FunctionComponent<LawyerProfilProps> = (
  props,
): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '32'}
      height={props.height || '32'}
      viewBox="0 0 32 32"
    >
      <g id="Group_450" data-name="Group 450" transform="translate(0 32)">
        <circle
          id="Ellipse_12"
          data-name="Ellipse 12"
          cx="16"
          cy="16"
          r="16"
          transform="translate(0 -32)"
          fill="#0075c9"
        />
        <g
          id="Ellipse_14"
          data-name="Ellipse 14"
          transform="translate(0 -32)"
          fill="none"
          stroke="#fff"
          strokeWidth="3.6"
        >
          <circle cx="16" cy="16" r="16" stroke="none" />
          <circle cx="16" cy="16" r="14.2" fill="none" />
        </g>
        <g
          id="Ellipse_13"
          data-name="Ellipse 13"
          transform="translate(0 -32)"
          fill="none"
          stroke="#0781c9"
          strokeWidth="1.8"
        >
          <circle cx="16" cy="16" r="16" stroke="none" />
          <circle cx="16" cy="16" r="15.1" fill="none" />
        </g>
        <g id="law" transform="translate(6.219 -58.805)">
          <g
            id="Group_1068"
            data-name="Group 1068"
            transform="translate(0 34.75)"
          >
            <path
              id="Path_531"
              data-name="Path 531"
              d="M20.941,49.952h-1.3V38.06h5.469L22.8,41.736a.4.4,0,0,0,.675.425l2.009-3.188,2.009,3.188a.4.4,0,0,0,.675-.425L25.847,38.06h.029a.618.618,0,1,0,0-1.237H21.328a2.024,2.024,0,0,0-1.08-.791,1.408,1.408,0,0,0-2.8,0,2.024,2.024,0,0,0-1.08.791H11.815a.618.618,0,1,0,0,1.237h.029L9.528,41.736a.4.4,0,0,0,.675.425l2.009-3.188,2.009,3.188a.4.4,0,0,0,.675-.425L12.579,38.06h5.469V49.952h-1.3a1.406,1.406,0,0,0-1.406,1.406h7A1.406,1.406,0,0,0,20.941,49.952Z"
              transform="translate(-9.064 -34.75)"
              fill="#fff"
            />
            <path
              id="Path_532"
              data-name="Path 532"
              d="M6.083,223.359H.213a.213.213,0,0,0-.213.213,3.148,3.148,0,0,0,6.3,0A.213.213,0,0,0,6.083,223.359Z"
              transform="translate(0 -215.337)"
              fill="#fff"
            />
            <path
              id="Path_533"
              data-name="Path 533"
              d="M318.048,223.359h-5.871a.213.213,0,0,0-.213.213,3.148,3.148,0,0,0,6.3,0A.213.213,0,0,0,318.048,223.359Z"
              transform="translate(-298.697 -215.337)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LawyerProfil;
